console.log("Hello from offer.js!")

import "./application";
import '../utils/splide';
import '../apps/on_boarding/main';

const get_offer_now = document.getElementById('get_offer_now');
if (get_offer_now) {
  get_offer_now.addEventListener('click', (e) => {
    e.preventDefault();
    // Both signed-in and signed-out users go straight to checkout. The
    // controller branches on auth state and routes signed-out buyers through
    // the pay-then-signup claim flow.
    const url = new URL(window.checkout_url, window.location.origin);
    if (window.Rewardful && window.Rewardful.referral) {
      url.searchParams.set('referral', window.Rewardful.referral);
    }
    window.location.href = url.toString();
  });
}
